import React from 'react';
import { useParams } from 'react-router-dom';
import { compose } from 'recompose';
import {
  renderWhileLoading,
  setRefetchProp,
  renderForError,
} from '../../../state/apolloRecompose';

import AccountHolderDetails from './AccountHolderDetails';

import withAccountHolderQuery from './enhancers/withAccountHolderQuery';
import withSearchDataState from './enhancers/withSearchDataState';
import withParamsState from './enhancers/withParamsState';
import withSearchByState from './enhancers/withSearchByState';
import withFilterButtonState from './enhancers/withFilterButtonState';
import withSearchFilterState from './enhancers/withSearchFilterState';
import withHandlers from './enhancers/withHandlers';

const ComposedAccountHolderDetails = compose(
  withSearchDataState,
  withParamsState,
  withSearchByState,
  withFilterButtonState,
  withSearchFilterState,
  withAccountHolderQuery,
  withHandlers,
  renderWhileLoading,
  setRefetchProp,
  renderForError
)(AccountHolderDetails);

// Wrapper to inject route params as match prop for compatibility with HOCs
export default function AccountHolderDetailsWrapper(props) {
  const params = useParams();

  return <ComposedAccountHolderDetails {...props} match={{ params }} />;
}
